import React from 'react';
import styles from './TeamCreation.module.css';
import Button from '../components/Button';
import ButtonAlt from '../components/ButtonAlt';
import InputField from '../components/InputField';
import ButtonX from '../components/ButtonX';
import * as constants from '../constants';

const TeamCreation = (props) => {

    let addButton = null;

    const teamsInputs = props.teams.map((t, index) => {
        const field = <InputField id={t.id} value={t.name}
            onChange={(event) => props.handleTeamNameChange(event, t.id)} />;
        let removeButton = null;
        if (index === props.teams.length - 1 && index > 1)
            removeButton = <ButtonX color='red' onClick={() => { props.removeTeam(); }} />
        return (
            <div key={t.id} className={styles.fieldWrapper}>
                <div>{field}</div>
                <div className={styles.removeButton}>{removeButton}</div>
            </div>
        );
    });

    if (props.teams.length === 2 || props.teams.length === 3)
        addButton =
            <ButtonAlt onClick={() => {
                props.addTeam();
            }}>{constants.TEXT9}</ButtonAlt>;

    return (
        <>
            <div className={styles.buffer}></div>
            <div className={styles.container}>
                {teamsInputs}
                <div className={styles.addButton}>
                    {addButton}
                </div>
                <div className={styles.playButton}>
                    <Button onClick={() => {
                        props.changeContainer('game');
                        props.checkTeamName();
                    }}>
                        {constants.TEXT10}
                    </Button>
                </div>
            </div>
        </>
    );
}

export default TeamCreation;